"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiOutlineInputStyles = void 0;
var component_2023_utils_token_parser_1 = require("@rentspree/component-2023.utils.token-parser");
exports.muiOutlineInputStyles = {
    styleOverrides: {
        notchedOutline: {
            borderColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.outline-color'),
            borderWidth: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.outline-width'),
            borderRadius: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.shape'),
            padding: "0px calc(".concat((0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-left'), " - calc(").concat((0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.label-text.populated.padding-left'), " + 1px))"),
            legend: {
                fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.label-text.populated.size'),
                span: {
                    paddingTop: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.label-text.populated.padding-top'),
                    paddingBottom: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.label-text.populated.padding-bottom'),
                    paddingLeft: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.label-text.populated.padding-left'),
                    paddingRight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.label-text.populated.padding-right'),
                },
            },
        },
        input: {
            margin: 0,
            paddingTop: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-top'),
            paddingBottom: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-bottom'),
            paddingLeft: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-left'),
            paddingRight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-right'),
            color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.input-text.color'),
            fontWeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.input-text.weight'),
            fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.input-text.size'),
            letterSpacing: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.input-text.letter-spacing'),
            lineHeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.input-text.line-height'),
            height: "calc(".concat((0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.height'), " - (").concat((0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-top'), " + ").concat((0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-bottom'), "))"),
        },
        inputMultiline: {
            minHeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.multiline.container.min-height'),
            height: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.multiline.container.height'),
            margin: 0,
            paddingTop: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-top'),
            paddingBottom: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-bottom'),
            paddingLeft: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-left'),
            paddingRight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.padding-right'),
            color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.input-text.color'),
            fontWeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.input-text.weight'),
            fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.input-text.size'),
            letterSpacing: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.input-text.letter-spacing'),
            lineHeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.input-text.line-height'),
        },
        multiline: {
            padding: 0,
        },
        root: {
            letterSpacing: 0.5,
            width: '100%',
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.hovered.container.outline-color'),
            },
            '&:focus-within .MuiOutlinedInput-notchedOutline': {
                borderColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.focused.container.outline-color'),
                borderWidth: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.focused.container.outline-width'),
            },
            '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                borderColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.error.container.outline-color'),
            },
            '&:focus-within.Mui-error .MuiOutlinedInput-notchedOutline': {
                borderColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.error-focused.container.outline-color'),
                borderWidth: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.error-focused.container.outline-width'),
            },
            '&.Mui-disabled': {
                '.MuiOutlinedInput-notchedOutline': {
                    borderColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.container.outline-color'),
                },
                '.MuiSvgIcon-root': {
                    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.disabled.adornment-icon.color'),
                },
                '.MuiTypography-root': {
                    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.textfield.disabled.adornment-text.color'),
                },
            },
        },
    },
};
//# sourceMappingURL=outline-input.js.map